import FundingSetupContainer from "./FundingSetup.container";

export default FundingSetupContainer;
